import { Routes, Route, useLocation } from "react-router-dom";
import Main from "./Main";
import Portfolio from "./Portfolio";
import About from "./About";
import Contact from "./Contact";
import { AnimatePresence } from "framer-motion";

function AnimatedRoutes() {
	const location = useLocation();

	return (
		<AnimatePresence mode="wait">
			<Routes location={location} key={location.pathname}>
				<Route path="/about" element={<About />} />
				<Route path="/portfolio" element={<Portfolio />} />
				<Route path="/contact" element={<Contact />} />
				<Route path="*" element={<Main />} />
			</Routes>
		</AnimatePresence>
	);
}

export default AnimatedRoutes;
